<template lang="html">
  <div class="custom-time-bubble vh100">
    <div class="custom-time-bubble-main">
      <div>
        <img src="./img/icon.png" alt="">
        <h1>您已定制成功</h1>
        <p>陪伴学习，让您变得更好</p>
      </div>
      <div>
        <p>从明天开始我们将在<span><slot></slot></span>提醒您</p>
        <p>学习哦~祝您学习愉快~(´▽`)ﾉ</p>
      </div>

      <UIButton class="button" width="260" height="64" fontSize="30" @click="closeBubble">
        我知道了
      </UIButton>
    </div>
  </div>
</template>

<script>
import UIButton from '../UI/Button'
export default {
  name: 'CustomTimeBubble',
  components: {
    UIButton
  },
  methods: {
    closeBubble () {
      this.$emit('closeBubble')
    }
  }
}

</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../../style/main";

  .custom-time-bubble {
    position: fixed;
    z-index: 9999;
    width: 100%;
    /*height: 100%;*/
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;

    .button {
      font-weight: bold;
    }

    &-main {
      width: rem(450);
      height: rem(549);
      padding: rem(69) 0;
      border-radius: rem(10);

      box-sizing: border-box;
      background: #fff;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      img {
        width: rem(98);
        height: rem(98);
        margin-bottom: rem(19);
      }

      h1 {
        font-size: rem(30);
      }

      p {
        font-size: rem(24);
        color: #999999;
        line-height: 1.3;
        > span {
          color: #F46D00;
        }
      }
    }
  }

</style>
